import { z } from 'zod'
import {
  DEFAULT_RECRUITING_INVITATION_EXPIRY_DAYS,
  MAX_RECRUITING_INVITATION_EXPIRY_DAYS,
} from '../constants'
import { RecruitingEmploymentStatusEnum, RecruitingPayTypeEnum } from '../types'

export const createRecruitingRequestSchema = z
  .object({
    clientPublicKey: z.string().uuid(),
    benefitEffectiveDate: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format'),
    contributionGroup: z.string(),
    employmentStatus: z.nativeEnum(RecruitingEmploymentStatusEnum),
    isExempt: z.boolean().default(false),
    payType: z.nativeEnum(RecruitingPayTypeEnum).optional(),
    expiryDays: z
      .number()
      .int()
      .min(1)
      .max(MAX_RECRUITING_INVITATION_EXPIRY_DAYS)
      .default(DEFAULT_RECRUITING_INVITATION_EXPIRY_DAYS),
    isSendEmail: z.boolean().default(false),
    recipientEmail: z.string().email().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.isSendEmail && !data.recipientEmail) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'recipientEmail is required when isSendEmail is true',
        path: ['recipientEmail'],
      })
    }
  })

export type CreateRecruitingRequest = z.infer<
  typeof createRecruitingRequestSchema
>
